<template>
  <span class="decrypt" v-double-click-copy="state.result || ''">
    <template v-if="props.phone">
      {{ state.showEye ? props.phone : state.result || '--' }}
      <LoadingOutlined v-show="state.loading" class="ml-4" style="font-size: 16px; color: var(--primary-color)" />
      <EyeInvisibleTwoTone
        v-show="!state.loading && state.showEye"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
      <EyeTwoTone
        v-show="!state.loading && !state.showEye"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
    </template>
    <template v-else> -- </template>
  </span>
</template>
<script setup lang="ts" name="DecryptIdCard">
  import { reactive } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone, LoadingOutlined } from '@ant-design/icons-vue'
  import { getPhoneService } from '@/service/api'
  import { useApi } from '@xinghai/site-common'
  import { isSuccess, getPrimaryColor } from '@/utils'
  
  interface Props {
    id: string
    phone: string
    /** 场景值 */
    scenes: string
  }
  const primaryColor = getPrimaryColor()
  const props = defineProps<Props>()
  /**查看手机号 */
  const state = reactive({
    /** 加载中 */
    loading: false,
    /** 显示眼睛 */
    showEye: true,
    /** 结果 */
    result: ''
  })
  const fechPhoneData = useApi(getPhoneService.getPhone)
  const getCardId = async () => {
    if (state.result) {
      state.showEye = !state.showEye
      return
    }
    state.loading = true
    fechPhoneData
      .fetchData({
        paramOne: props.id,
        paramTwo: props.scenes
      })
      .then((res) => {
        if (isSuccess(res)) {
          state.result = res.data
        }
      })
      .finally(() => {
        state.loading = false
        state.showEye = !state.showEye
      })
  }
</script>
<style lang="less" scoped>
  .decrypt {
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
